import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{},[_c('person-vehicles-table',{attrs:{"person-id":_vm.personId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }